const getModuleState = (state) => state.maps;

export const getMap = (state) => getModuleState(state).map;
export const getSession= (state) => getModuleState(state).session;
export const getSummary= (state) => getModuleState(state).summary;